import ShiptypeBaseController from '../common/shiptype.base.controller'

class ShiptypeEditController extends ShiptypeBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, ShiptypeService, Modal, $translate, $stateParams, CommonLayoutService) {
		super(Auth, $state, User, ShiptypeService, Modal, $translate, $stateParams)
		this.pageName = `shiptype`
		this.Auth = Auth
		this.$state = $state
		this.User = User
		this.CommonLayoutService = CommonLayoutService;
		this.message = 'Shiptype create'
		this.rawId = ''
		this.defaultModel = {
			id: '',
			description: '',
			status: true,
			amountFlag: false,
			unitValue: '',
			amount: '',
			coinFlag: false,
			hhtFlag: true,
			batchField: '',
			sortOrder: 1,
			denominationType: null,
			countable: false,
			daysToCount: null,
            selectedFiles:[],
		}
		this.model = angular.copy(this.defaultModel)
		this.toggleSwitchUI = {
			size: 'small',
			label: {
				on: this.$translate.instant('common.yes'),
				off: this.$translate.instant('common.no')
			},
			onColor: 'success',
			offColor: 'danger'
		}
		this.branchId = this.User.getUser().branchId;
		this.denominationTypes = this.CommonLayoutService.denominationTypes();
	}
	$onInit() {
        this.model.loading = true;
		this.Service.get(this.$stateParams.id)
			.then((data) => {
				this.defaultModel = data;
				this.rawId = data.id
				this.model.id = data.id
				this.model.status = data.status;
				this.model.description = data.description
				this.model.amountFlag = data.amountFlag
				this.model.amount = (this.model.amountFlag || data.amount) ? data.amount : null;
				this.model.unitValue = data.unitValue
				this.model.coinFlag = data.coinFlag
				this.model.hhtFlag = data.hhtFlag
				this.model.batchField = data.batchField
				this.model.sortOrder = data.sortOrder
				this.model.denominationType = data.denominationType;
				this.model.countable = data.countable;
				this.model.daysToCount = data.daysToCount;
				this.model.isIconExists = data.isIconExists;
                // this.model.imageData = data.imageData;
			})
			.catch((err) => {
                console.log(err);
	        })
			.finally(() => {
                this.model.loading = false;
            })
	}

	reset() {
		this.model = angular.copy(this.defaultModel)
	}

	submit(evt) {
		this.loading = true
		let shiptypeIcon = [];
        if (this.model.selectedFiles && this.model.selectedFiles.length && this.model.selectedFiles[0].hasOwnProperty('base64Data')) {
            this.model.selectedFiles.forEach((d) => {
                shiptypeIcon.push({ base64String: d.base64Data, fileName: `${this.rawId}.png`});
            })
        }
		const changedObj = this.findDifferencesWithReturn(this.defaultModel, this.model);
		this.Service.update(this.rawId, {
			id: this.rawId,
			status: this.model.status,
			description: this.model.description,
			amountFlag: this.model.amountFlag,
			amount: this.model.amountFlag ? this.model.amount : 0,
			unitValue: this.model.unitValue,
			coinFlag: this.model.coinFlag,
			hhtFlag: this.model.hhtFlag,
			batchField: this.model.batchField,
			sortOrder: this.model.sortOrder,
			denominationType: this.model.denominationType,
			countable: this.model.countable,
			daysToCount: this.model.daysToCount === '' ? null : this.model.daysToCount,
			shiptypeIcon
		}, this.branchId, changedObj)
			.then((data) => {
				this.loading = false
				window.history.go(-1)
			})
			.catch((err) => {
				this.loading = false
				err.data.errors.map((e) => {
					this.errorMessage += e.message + '<br/>'
				})
			})
	}
	findDifferencesWithReturn(objA, objB) {
		function compareObjects(obj1, obj2) {
			let diff = {};

			for (let key in obj1) {
				if (obj1.hasOwnProperty(key)) {

					if (['locationDenomination', 'locationScheduleRecurringData', 'scheduledLocations'].includes(key)) {
						continue; // Skip these keys
					}

					if (typeof obj1[key] === 'object' && obj1[key] !== null && obj2[key] !== null) {
						if (Array.isArray(obj1[key])) {
							if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
								diff[key] = {
									"Old Value": obj1[key],
									"Updated Value": obj2[key]
								};
							}
						} else if (obj2[key] !== undefined && obj1[key] !== undefined) {
							const nestedDiff = compareObjects(obj1[key], obj2[key]);
							if (Object.keys(nestedDiff).length > 0) {
								diff[key] = nestedDiff;
							}
						}
					} else if (obj1[key] !== obj2[key] && obj2[key] !== undefined && obj1[key] !== undefined) {
						if (key === 'status') {
							diff[key] = {
								"Old Value": obj1[key] ? "Active" : "Suspended",
								"Updated Value": obj2[key] ? "Active" : "Suspended"
							};
						}
						else {
							diff[key] = {
								"Old Value": obj1[key],
								"Updated Value": obj2[key]
							};
						}
					}
				}
			}
			return diff;
		}
		return compareObjects(objA, objB);
	}
	askToChange() {
		if (!this.model.status) {
			this.model.status = !this.model.status
			this.Modal.confirm({
				header: this.$translate.instant(`${this.pageName}.suspend_${this.pageName}`),
				message: this.$translate.instant(`${this.pageName}.suspend_${this.pageName}_message`),
				callback: ({
					modal,
					$scope
				}) => {
					this.model.status = !this.model.status
					modal.close()
				},
				negative: ({
					modal,
					$scope
				}) => {
					modal.close()
				},
				type: 'danger',
				buttons: [this.$translate.instant('common.yes'), this.$translate.instant('common.no')]
			})
		}
	}
}

export default ShiptypeEditController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/shiptype/edit/shiptype.edit.controller.js